import { PaginationNext, PaginationPrevious } from '@/components/ui/pagination';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const PAGE_SIZES = [10, 20, 30, 40, 50];

interface PaginationFooterProps {
  /** 1-based current page. */
  page: number;
  pageCount: number;
  /** Left part of the summary, e.g. « 128 lignes » — the « Page x / y » suffix is appended. */
  summary: string;
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  onPageChange: (page: number) => void;
  isFetching?: boolean;
}

/** Shared list footer: page-size select, count summary, previous/next. */
export function PaginationFooter({
  page,
  pageCount,
  summary,
  pageSize,
  onPageSizeChange,
  onPageChange,
  isFetching,
}: PaginationFooterProps) {
  return (
    <div className="flex items-center justify-between pt-2">
      <div className="hidden sm:flex items-center space-x-2">
        <p className="text-sm text-slate-500">Par page</p>
        <Select
          value={`${pageSize}`}
          onValueChange={(value) => onPageSizeChange(Number(value))}
        >
          <SelectTrigger className="h-8 w-[70px] bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent side="top">
            {PAGE_SIZES.map((size) => (
              <SelectItem key={size} value={`${size}`}>
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-slate-500">
          {summary} · Page {page} / {pageCount}
        </span>
        {isFetching && (
          <div className="animate-spin h-3 w-3 border-2 border-emerald-500 border-t-transparent rounded-full" />
        )}
        <PaginationPrevious
          onClick={() => {
            if (page > 1) onPageChange(page - 1);
          }}
          aria-disabled={page <= 1}
          className={page <= 1 ? 'pointer-events-none opacity-50' : ''}
          aria-label="Page précédente"
        />
        <PaginationNext
          onClick={() => {
            if (page < pageCount) onPageChange(page + 1);
          }}
          aria-disabled={page >= pageCount}
          className={page >= pageCount ? 'pointer-events-none opacity-50' : ''}
          aria-label="Page suivante"
        />
      </div>
    </div>
  );
}
